import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { RedeemWindowService } from '../services/redeem-window.service';

export const redirectToShowcodeGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const redeemWindowService = inject(RedeemWindowService);

  if (!redeemWindowService.isExpired()) {
    router.navigate(['/code'], {
      queryParams: {
        location: redeemWindowService.getParam(),
      },
    });
    return false;
  }
  return true;
};
